var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "custom-tbl" }, [
      _c("thead", { staticClass: "head" }, [
        _c("tr", { staticClass: "row" }, [
          _c("th", { staticStyle: { "text-align": "left" } }, [
            _vm._v("区域名称")
          ]),
          _vm._v(" "),
          _c(
            "th",
            { staticStyle: { "text-align": "left" }, attrs: { width: "200" } },
            [_vm._v("经营业态")]
          ),
          _vm._v(" "),
          _vm.kindId != null && _vm.kindId == 0
            ? _c(
                "th",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { width: "100" }
                },
                [_vm._v("数量")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "th",
            { staticStyle: { "text-align": "right" }, attrs: { width: "120" } },
            [_vm._v("含税价(元)")]
          ),
          _vm._v(" "),
          _c(
            "th",
            { staticStyle: { "text-align": "right" }, attrs: { width: "120" } },
            [_vm._v("税率(%)")]
          ),
          _vm._v(" "),
          _c(
            "th",
            { staticStyle: { "text-align": "right" }, attrs: { width: "120" } },
            [_vm._v("未税价(元)")]
          ),
          _vm._v(" "),
          _vm.kindId != null && _vm.kindId == 0
            ? _c(
                "th",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { width: "120" }
                },
                [_vm._v("含税小计(元)")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.operateContract != "chakan"
            ? _c("th", { attrs: { width: "80", align: "left" } }, [
                _vm._v("操作")
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "body" },
        [
          _vm._l(_vm.areaPriceList, function(areaPrice, index) {
            return _c("tr", { staticClass: "row" }, [
              _c("td", { staticStyle: { "text-align": "left" } }, [
                _vm._v(_vm._s(areaPrice.bizAreaName))
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "text-align": "left" } },
                _vm._l(areaPrice.bizFormNameList, function(bizFormName) {
                  return areaPrice.bizFormNameList != null &&
                    areaPrice.bizFormNameList.length > 0
                    ? _c("div", [
                        _c(
                          "span",
                          { staticClass: "swb-tags swb-tags-success mr5" },
                          [_vm._v(_vm._s(bizFormName))]
                        )
                      ])
                    : _vm._e()
                })
              ),
              _vm._v(" "),
              _vm.kindId != null && _vm.kindId == 0
                ? _c(
                    "td",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _vm.operateContract != "chakan"
                        ? _c("el-input", {
                            attrs: {
                              maxlength: 9,
                              disabled:
                                (_vm.disabled ||
                                  _vm.operateContract == "chakan") &&
                                _vm.operateContract != "change",
                              type: "text"
                            },
                            on: {
                              change: function($event) {
                                _vm.quantityChange(areaPrice.quantity, index)
                              }
                            },
                            model: {
                              value: areaPrice.quantity,
                              callback: function($$v) {
                                _vm.$set(areaPrice, "quantity", _vm._n($$v))
                              },
                              expression: "areaPrice.quantity"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.operateContract == "chakan"
                        ? _c("span", [_vm._v(_vm._s(areaPrice.quantity))])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "text-align": "right" } },
                [
                  _vm.operateContract != "chakan"
                    ? _c("el-input", {
                        attrs: {
                          maxlength: 9,
                          disabled:
                            (_vm.disabled || _vm.operateContract == "chakan") &&
                            _vm.operateContract != "change",
                          type: "text"
                        },
                        on: {
                          change: function($event) {
                            _vm.priceChange(areaPrice.price, index)
                          }
                        },
                        model: {
                          value: areaPrice.price,
                          callback: function($$v) {
                            _vm.$set(areaPrice, "price", $$v)
                          },
                          expression: "areaPrice.price"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operateContract == "chakan"
                    ? _c("span", [_vm._v(_vm._s(areaPrice.price))])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "right" } }, [
                _vm._v(_vm._s(_vm.taxRate))
              ]),
              _vm._v(" "),
              _c("td", { staticStyle: { "text-align": "right" } }, [
                _vm._v(_vm._s(areaPrice.ntxPrice))
              ]),
              _vm._v(" "),
              _vm.kindId != null && _vm.kindId == 0
                ? _c("td", { staticStyle: { "text-align": "right" } }, [
                    _vm._v(_vm._s(areaPrice.amount))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.operateContract != "chakan"
                ? _c("td", { attrs: { align: "left" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.removeAreaPrice(areaPrice.bizAreaId)
                          }
                        }
                      },
                      [_vm._v("移除")]
                    )
                  ])
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _c("tr", { staticClass: "row" }, [
            _vm.operateContract != "chakan"
              ? _c(
                  "td",
                  {
                    staticClass: "display-none",
                    attrs: {
                      colspan: _vm.kindId != null && _vm.kindId == 0 ? 8 : 6
                    }
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.operateContract == "chakan"
              ? _c(
                  "td",
                  {
                    staticClass: "display-none",
                    attrs: {
                      colspan: _vm.kindId != null && _vm.kindId == 0 ? 7 : 5
                    }
                  },
                  [_vm._m(1)]
                )
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("tfoot", { staticClass: "foot" }, [
        _c("tr", { staticClass: "row" }, [
          _vm.operateContract != "chakan"
            ? _c(
                "td",
                {
                  attrs: {
                    colspan: _vm.kindId != null && _vm.kindId == 0 ? 8 : 6
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.selectBizArea()
                        }
                      }
                    },
                    [_vm._m(2)]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.areaPriceList.length <= 0 && _vm.operateContract == "chakan"
            ? _c(
                "td",
                {
                  attrs: {
                    colspan: _vm.kindId != null && _vm.kindId == 0 ? 7 : 5
                  }
                },
                [_vm._m(3)]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("i", {
        staticClass: "icon iconfont icon-zanwushuju mr10",
        staticStyle: { "font-size": "58px", "vertical-align": "middle" }
      }),
      _vm._v(" "),
      _c("span", {}, [_vm._v("暂无数据 . . .")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("i", {
        staticClass: "icon iconfont icon-zanwushuju mr10",
        staticStyle: { "font-size": "58px", "vertical-align": "middle" }
      }),
      _vm._v(" "),
      _c("span", {}, [_vm._v("暂无数据 . . .")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "icon iconfont icon-jiahao mr5" }),
      _vm._v("选择经营区域\n                        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swb-btn-link" }, [
      _c("span", {}, [_vm._v("暂无数据 . . .")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f716d066", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f716d066","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractGoodsAreaPriceSave.vue
// module id = 3229
// module chunks = 0